const Content = {
  'services': {
    'smallTitle': 'Services',
    'qualitative': {
      'number': '01',
      'title': 'Qual.',
      'body': 'The foundation of our qualitative work is a team of passionate, subject matter experts who connect deeply with consumers in any environment. We use qual to discover the subconcious drivers that fuel our quantitative truths.'
    },
    'quantitative': {
      'number': '02',
      'title': 'Quant.',
      'body': 'Our quantitative work is anchored in sophisticated techniques with a focus on agility, creativity and rigor. We are method agnostic and work collaboratively with you to solve complex problems in a simple way.'
    },
    'storytelling': {
      'number': '03',
      'title': 'Storytelling',
      'body': 'Storytelling is at the heart of what we do. We synthesize disparate data into memorable, easy to understand and actionable narratives that empower our client to make informed decisions. Our final deliverable works hard so you don\'t have to.'
    }
  },
  'expertise': {
    'smallTitle': '',
    'content': {
      'number': '01',
      'title': 'Content',
      'body': 'The explosion of what, where and when content is available to consumers makes breaking through the clutter increasingly difficult. Our market-leading methods help creators and marketers identify the right message to deliver to the right audience at the right time.'
    },
    'interactive': {
      'number': '02',
      'title': 'Interactive',
      'body': 'Our innovative methods and industry expertise guide development, design, marketing and strategy where content and platform experiences converge.'
    },
    'platform': {
      'number': '03',
      'title': 'Platforms & Tech',
      'body': 'At the intersection of services, content, hardware and monetization, our platform work helps brands create and deliver optimized consumer experiences.'
    },
    'brand': {
      'number': '04',
      'title': 'Brand Marketers',
      'body': 'Our differentiated, consultative framework leverages insights to inform brand communication and growth strategy.'
    }
  },
  'network': {
    'smallTitle': '',
    'network': {
      'number': '',
      'title': 'NRG is a proud member of the Stagwell Group',
      'body': 'Led by a group of agency and industry professionals, Stagwell is building an investment portfolio of marketing services companies that puts digital first without being weighed down by legacy assets. The Stagwell Group has only one of each kind of agency from digital media buying to market research to public relations and beyond to allow for true cooperation. Most importantly, Stagwell knows great talent needs to be valued and nurtured to achieve best in class growth. To facilitate that growth, Stagwell acts as a value added investor, not simply a manager, through new business development, strategic counsel and add-on acquisitions that keep agencies like NRG on the cutting edge of marketing innovation. NRG was Stagwell’s second acquisition; as a full-service market research consultancy, we fit the Stagwell thesis perfectly and are excited to work with the other members of the Stagwell family.'
    },
    'extension': {
      logos: [
        {
          'className': 'ct',
          'viewBox': '0 0 185.8 13.7',
          'iconName': 'logo-candt'
        },
        {
          'className': 'skd',
          'viewBox': '0 0 185.8 26.6',
          'iconName': 'logo-skd'
        },
        {
          'className': 'nrg',
          'viewBox': '0 0 307.1 113.6',
          'iconName': 'nrg-stagwell'
        },
        {
          'className': 'pmx',
          'viewBox': '0 0 86.3 43.6',
          'iconName': 'logo-pmx'
        }
      ],
      'anchor': {
        'text': 'Visit the Stagwell Group',
        'href': 'http://www.stagwellgroup.com/'
      }
    }
  },
  'news': {
    'featuredArticle': {
      'title': '',
      'body': 'A Data Science Framework for Forecasting Opening Box Office Revenue'
    }
  },
};

export { Content };
